import {
  OrderBuilderActions,
  RESET_BUILDER,
} from '@ordersnproducts/modules/order-builder/actions/order-builder.actions';
import { OrderActionTypes, OrderActions } from '@ordersnproducts/modules/new-repeat-order/actions/order.actions';

export interface OrderState {
  loading: boolean;
  orderResponse: any;
  orderCode: string;
}

export const initialState: OrderState = {
  loading: false,
  orderResponse: null,
  orderCode: null,
};

export function orderReducer(state = initialState, action: OrderActions | OrderBuilderActions): OrderState {
  switch (action.type) {
    case OrderActionTypes.REQUEST:
    case OrderActionTypes.REQUEST_UL: {
      return {
        ...state,
        loading: true,
      } as OrderState;
    }
    case OrderActionTypes.REQUEST_COMPLETE: {
      return {
        ...state,
        loading: false,
        orderResponse: action.payload,
      } as OrderState;
    }
    case RESET_BUILDER:
    case OrderActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
